import React, { useState, useEffect, useMemo } from 'react';
import store from 'state-managament';
import { Routes } from 'routes';
import { Provider } from 'react-redux';
import ErrorBoundary from 'components/ErrorBoundary';
import AuthProvider from 'components/AuthProvider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CircularProgress, Backdrop } from '@mui/material';
import "typeface-montserrat";
import { getDesignTokens } from './theme.js';


const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

export default function App () {
  const [isLoading, setIsLoading] = useState(true);
  const [mode, setMode] = useState('light');
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => setMode((prevMode) => prevMode === 'light' ? 'dark' : 'light')
    }),
    [],
  );

  // Update the theme only if the mode changes
  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <Provider store={store}>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <AuthProvider>
              { isLoading ?
                (
                  <Backdrop
                    invisible
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                  >
                    <CircularProgress color="primary" />
                  </Backdrop>
                )
                :(
                  <Routes />
                )
              }
            </AuthProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </Provider>
  );
}
